import { applyPortraitMode } from './effects/PortraitModeEffect';
import { applyLandscapeMode } from './effects/LandscapeModeEffect';
import { applyMacroMode } from './effects/MacroModeEffect';
import { applyHDRMode } from './effects/HDRModeEffect';
import { applyBlackWhiteMode } from './effects/BlackWhiteModeEffect';
import { applyVintageMode } from './effects/VintageModeEffect';
import { applyVividMode } from './effects/VividModeEffect';
import { applySoftMode } from './effects/SoftModeEffect';
import { applyOutFocusMode } from './effects/OutFocusModeEffect';
import { applyPaintingMode } from './PaintingModeEffect';

class CanonEffectProcessor {
  static async processImage(imageFile, presetType, paintingStyle, artStyle, setMessage, language) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = async (event) => {
        const img = new Image();
        
        img.onload = async () => {
          try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            // 캔버스 크기를 이미지 크기로 설정
            canvas.width = img.width;
            canvas.height = img.height;
            
            // 기본 이미지 그리기
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            
            // 선택된 프리셋에 따라 효과 적용
            switch (presetType) {
              case 'portrait':
                await applyPortraitMode(canvas, ctx, setMessage, language);
                break;
                
              case 'landscape':
                await applyLandscapeMode(canvas, ctx, setMessage, language);
                break;
                
              case 'macro':
                await applyMacroMode(canvas, ctx, setMessage, language);
                break;
                
              case 'hdr':
                await applyHDRMode(canvas, ctx, setMessage, language);
                break;
                
              case 'blackwhite':
                await applyBlackWhiteMode(canvas, ctx, setMessage, language);
                break;
                
              case 'vintage':
                await applyVintageMode(canvas, ctx, setMessage, language);
                break;
                
              case 'vivid':
                await applyVividMode(canvas, ctx, setMessage, language);
                break;
                
              case 'soft':
                await applySoftMode(canvas, ctx, setMessage, language);
                break;
              
              case 'outfocus':
                await applyOutFocusMode(canvas, ctx, setMessage, language);
                break;

              case 'painting':
                await applyPaintingMode(canvas, ctx, paintingStyle, artStyle, setMessage, language);
                break;  

              default:
                throw new Error('Unknown preset type');
            }
            
            // 처리된 이미지 URL 반환
            const dataURL = canvas.toDataURL('image/jpeg', 0.9);
            resolve(dataURL);
            
          } catch (error) {
            console.error('Error processing image:', error);
            reject(error);
          }
        };
        
        img.onerror = (error) => {
          console.error('Error loading image:', error);
          reject(error);
        };
        
        img.src = event.target.result;
      };
      
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        reject(error);
      };
      
      reader.readAsDataURL(imageFile);
    });
  }
}

export default CanonEffectProcessor;